import * as i0 from '@angular/core';
import { EventEmitter, PLATFORM_ID, Component, ChangeDetectionStrategy, Inject, Input, Output, ViewChild, NgModule } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
const _c0 = ["ref"];
var YoutubeState = /*#__PURE__*/function (YoutubeState) {
  YoutubeState[YoutubeState["Unstarted"] = -1] = "Unstarted";
  YoutubeState[YoutubeState["Ended"] = 0] = "Ended";
  YoutubeState[YoutubeState["Playing"] = 1] = "Playing";
  YoutubeState[YoutubeState["Paused"] = 2] = "Paused";
  YoutubeState[YoutubeState["Buffering"] = 3] = "Buffering";
  YoutubeState[YoutubeState["Cued"] = 5] = "Cued";
  return YoutubeState;
}(YoutubeState || {});
class YoutubeUtility {
  static VideoIdFromUrl(url) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length === 11 ? match[7] : url;
  }
}
let YoutubePlayerComponent = /*#__PURE__*/(() => {
  class YoutubePlayerComponent {
    get host() {
      console.log(this.cookies);
      return !this.cookies ? 'https://www.youtube-nocookie.com' : null;
    }
    constructor(platformId) {
      this.platformId = platformId;
      this.ready = new EventEmitter();
      this.play = new EventEmitter();
      this.end = new EventEmitter();
      this.pause = new EventEmitter();
      this.change = new EventEmitter();
      this.error = new EventEmitter();
      this.stateClassName = 'is--unloaded';
    }
    async ngOnInit() {
      if (!isPlatformBrowser(this.platformId)) {
        return;
      }
      const YT = await this.apiLoaded();
      this.player = new YT.Player(this.ref.nativeElement, {
        videoId: YoutubeUtility.VideoIdFromUrl(this.src),
        host: this.host,
        playerVars: this.config,
        events: {
          onReady: e => this.ready.emit(e),
          onError: e => this.error.emit(e),
          onStateChange: e => {
            const stateName = YoutubeState[e.data].toLowerCase();
            this.stateClassName = `is--${stateName}`;
            if (e.data === YoutubeState.Playing) {
              this.play.emit(e);
            }
            if (e.data === YoutubeState.Paused) {
              this.pause.emit(e);
            }
            if (e.data === YoutubeState.Ended) {
              this.end.emit(e);
            }
            this.change.emit(e);
          }
        }
      });
    }
    apiLoaded() {
      return new Promise((resolve, reject) => {
        const tag = document.createElement('script');
        tag.id = 'youtube-component-api';
        tag.src = 'https://www.youtube.com/iframe_api';
        const exist = document.getElementById(tag.id);
        if (!exist) {
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
        let timeout = 0;
        const maxTimeout = 30000;
        const interval = 100;
        const timer = setInterval(() => {
          const YT = window.YT;
          timeout += interval;
          if (timeout >= maxTimeout) {
            clearInterval(timer);
            reject(new Error('Youtube Api not loaded'));
          } else if (YT && YT.Player) {
            clearInterval(timer);
            resolve(YT);
          }
        }, interval);
      });
    }
    static {
      this.ɵfac = function YoutubePlayerComponent_Factory(t) {
        return new (t || YoutubePlayerComponent)(i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: YoutubePlayerComponent,
        selectors: [["fstr-youtube-player"]],
        viewQuery: function YoutubePlayerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ref = _t.first);
          }
        },
        inputs: {
          src: "src",
          config: "config",
          cookies: "cookies"
        },
        outputs: {
          ready: "ready",
          play: "play",
          end: "end",
          pause: "pause",
          change: "change",
          error: "error"
        },
        decls: 3,
        vars: 3,
        consts: [["ref", ""], [1, "fstr-youtube__container__iframe"]],
        template: function YoutubePlayerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵelement(1, "div", 1, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("fstr-youtube__container ", ctx.stateClassName, "");
          }
        },
        styles: [".fstr-youtube__container[_ngcontent-%COMP%]{width:100%;height:0;overflow:hidden;padding-bottom:56.25%;position:relative;display:block}  .fstr-youtube__container__iframe{width:100%;height:100%;position:absolute;inset:0}"],
        changeDetection: 0
      });
    }
  }
  return YoutubePlayerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let YoutubePlayerModule = /*#__PURE__*/(() => {
  class YoutubePlayerModule {
    static {
      this.ɵfac = function YoutubePlayerModule_Factory(t) {
        return new (t || YoutubePlayerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: YoutubePlayerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return YoutubePlayerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { YoutubePlayerComponent, YoutubePlayerModule, YoutubeState, YoutubeUtility };
